import { Link } from "react-router-dom";

import { Range } from "../../../@types/visualization";
import { htmlEncode } from "../../../util";
import { SVG_PARAMS } from "../consts";

const TOP_OFFSET = 2;

interface Props {
  regionLinks: Record<string, string>;
  ranges: Array<Range>;
  columns?: number;
  height: number;
}

const RangeList = ({ regionLinks, ranges, columns = 1, height }: Props) => {
  const { blockSize } = SVG_PARAMS;

  return (
    <div className="file-visualization__ranges" style={{ height }}>
      {ranges.map(({ name, first }, index) => {
        const topPosition = (first / columns) * blockSize - blockSize;
        return (
          <div
            className={htmlEncode(name.toLowerCase().replace(".", ""))}
            style={{ top: topPosition + TOP_OFFSET }}
            key={index}
          >
            <Link to={regionLinks[name]}>{name}</Link>
          </div>
        );
      })}
    </div>
  );
};

export default RangeList;
